import { render, staticRenderFns } from "./comp_dpc-OffersBoard.vue?vue&type=template&id=2d02b758&scoped=true&"
import script from "./comp_dpc-OffersBoard.vue?vue&type=script&lang=js&"
export * from "./comp_dpc-OffersBoard.vue?vue&type=script&lang=js&"
import style0 from "./comp_dpc-OffersBoard.vue?vue&type=style&index=0&id=2d02b758&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d02b758",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
